const Category = {
    STREET: 1,
    ESTATE: 2,
    DISTRICT: 3,
    CITY: 4,
    SUBURB: 5
}

export default Category;